import React, { useState } from "react";

import { Edit } from "icons";

import { Button, Textarea, Typography } from "clearsense-ui/components";

const TextAreaWithButton = ({ defaultValue = "", title, handleSave }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [text, setText] = useState(defaultValue);
  const [previous, setPrevious] = useState("");

  const handleDiscard = () => {
    setText(previous);
    setIsDisabled(true);
  };

  const handlePrimaryAction = () => {
    handleSave(text);
    setPrevious(text);
    setIsDisabled(true);
  };

  return (
    <div className="p-6 border rounded shadow-sm">
      <div className="flex justify-between">
        <Typography
          style="h4"
          type="semibold"
          className="text-gray-900 dark:text-gray-400"
        >
          {title}
        </Typography>
        <Button
          style="text"
          icon={Edit}
          iconSize={25}
          onClick={() => setIsDisabled(false)}
        />
      </div>
      <Textarea
        disabled={isDisabled}
        className="mt-6"
        value={text}
        onChange={e => setText(e.target.value)}
      />
      {!isDisabled && (
        <div className="mt-4">
          <Button onClick={handlePrimaryAction} label="Save and Close" />
          <Button
            onClick={handleDiscard}
            className="ml-2"
            label="Discard"
            style="secondary"
          />
        </div>
      )}
    </div>
  );
};

export default TextAreaWithButton;
